export const types = {
    AUTH_LOGIN: '[AUTH] Login',
    AUTH_LOGOUT: '[AUTH] Logout',
    AUTH_FINISH_CHECKING: '[AUTH] Finish checking'
}